export default function setWindowAttributes(payload) {
  return function somename(dispatch, getState) {
    dispatch({
      type: 'SET_WINDOW_ATTRIBUTES',
      payload,
    });
  };
}
